module.exports = __webpack_public_path__ + "static/img/list-amaraFullFaceMask.a670bf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maskPng/list-amaraFullFaceMask.png
// module id = q6QW
// module chunks = 1